import styled from "styled-components";

export const NavStyle = styled.nav`
  width: 100%;
  height: 55px;
  padding: 0 20px;
  justify-content: space-between;
  .logo {
    padding: 15px 0;
  }
`;

export const BurguerStyle = styled.div`
  width: 2rem;
  height: 2rem;
  z-index: 30;
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;
  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open }) => (open ? "#ccc" : "#333")};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;

export const ParentNav = styled.div`
  border-left: 1px solid green;
  list-style: none;
  display: flex;
  z-index: 25;
  flex-flow: row nowrap;
  li {
    padding: 18px 10px;
    color: #ffffff;
  }
  flex-flow: column nowrap;
  background-color: #F1F1F1;
  position: fixed;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  top: 0;
  right: 0;
  height: 100vh;
  width: 20rem;
  padding-top: 1.5rem;
  transition: transform 0.3s ease-in-out;
`;
